import { Directive, ElementRef, Inject, Renderer2, Input, OnInit, NgZone } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { UtilService } from '../../../shared/services';

@Directive({
  selector: '[appStickyHeader]'
})
export class StickyHeaderDirective implements OnInit {

  @Input() animate;
  @Input() headerTopSticky;
  @Input() isHome;
  @Input() isReferrer;
  lastKnownScrollY = 0;
  currentScrollY = 0;
  ticking = false;
  eleHeader;
  classes = {
    pinned: 'header-pin',
    unpinned: 'header-unpin',
  };
  constructor(
    public _element: ElementRef,
    @Inject(DOCUMENT) public document: any,
    public renderer: Renderer2,
    private zone: NgZone,
    private utilService: UtilService
  ) {
  }
  ngOnInit() {
    this.eleHeader = this._element.nativeElement;
    this.zone.runOutsideAngular(() => {
      this.renderer.listen('window', 'scroll', () => {
        this.onScroll();
      });
    });
  }

  onScroll() {
    if (typeof window !== 'undefined') {
      this.currentScrollY = window.pageYOffset;
    }
    if (this.animate) {
      this.update();
      // this.eleHeader.classList.remove('pos-rel-header');
      if (this.isHome) {
        if (window.pageYOffset > 200) {
          this.eleHeader.classList.add('topsticky');
        } else {
          this.eleHeader.classList.remove('topsticky');
        }
      }
      if (this.isReferrer) {
        if (window.pageYOffset > 50) {
          this.eleHeader.classList.add('topsticky');
        } else {
          this.eleHeader.classList.remove('topsticky');
        }
      }
      if (this.headerTopSticky) {
        this.eleHeader.classList.add('topsticky');
        this.pin();
      }
    } else {
      this.eleHeader.classList.remove(this.classes.pinned, this.classes.unpinned);
      // this.eleHeader.classList.add('pos-rel-header');
    }

  }

  requestTick() {
    if (!this.ticking) {
      requestAnimationFrame(this.update);
    }
  }
  update() {
    if (this.currentScrollY < this.lastKnownScrollY) {
      this.pin();
    } else if (this.currentScrollY > this.lastKnownScrollY) {
      this.unpin();
    }
    this.lastKnownScrollY = this.currentScrollY;
    this.ticking = false;
  }
  pin() {
    if (this.eleHeader.classList.contains(this.classes.unpinned)) {
      this.renderer.addClass(this.eleHeader, this.classes.pinned);
      this.renderer.removeClass(this.eleHeader, this.classes.unpinned);
    }
  }
  unpin() {
    if (this.eleHeader.classList.contains(this.classes.pinned) || !this.eleHeader.classList.contains(this.classes.unpinned)) {
      this.renderer.addClass(this.eleHeader, this.classes.unpinned);
      this.renderer.removeClass(this.eleHeader, this.classes.pinned);
    }
  }
}
